import { CalculatorsRequest, CalculatorsResponse } from "../models/calculators.models";
import {
  buildFuelCurve,
  calculateNormalizedStw,
  calculatePerformanceResult,
} from "../utils/calculators.utils";

// Uses modeled local equivalents of the backend contract only when the sidebar toggle is enabled.
export const calculateMockCalculators = (request: CalculatorsRequest): CalculatorsResponse => ({
  normalizedStw: calculateNormalizedStw(request.draft),
  ladenCurve: buildFuelCurve(request.fuelCurve.laden, request.fuelCurve.speedExponent),
  ballastCurve: buildFuelCurve(request.fuelCurve.ballast, request.fuelCurve.speedExponent),
  performance: request.performance.rows.map(calculatePerformanceResult),
  warnings: [
    "Performance branching is provisional because the PBIP does not contain its semantic-model DAX.",
    "The local modeled fuel grid follows the backend 9.0 to 18.0 kn contract in 0.1 kn steps.",
  ],
});
